import Common from '../../../Common';

const Trigger = class extends Common {
	browse = (destinationId: id) => this.get(`/callback/destination/${destinationId}/trigger`)
}

export default Trigger
